import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export default gql`
  query dokkioTag($id: DokkioID!) {
    dokkioTag(id: $id) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
